export const SUGGESTED_CHANNELS = [
  'email',
  'sms',
  'instagram',
  'facebook',
  'x',
  'tiktok',
  'linkedin',
  'youtube',
  'paid_search',
  'display_ad',
  'qr',
  'influencer',
  'push',
  'other',
] as const;

export type SuggestedChannel = (typeof SUGGESTED_CHANNELS)[number];

export const CHANNEL_SLUG_REGEX = /^[a-z0-9_-]{1,32}$/;
